import axios from 'axios';

const apiSemolis = axios.create({
  baseURL: process.env.REACT_APP_/_GO_STB_SEMOLIS,
});

export default apiSemolis;
